var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgChalice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.74 35.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#ffc088;}.cls-3,.cls-5{fill:#ffebd5;}.cls-3,.cls-4{mix-blend-mode:multiply;}.cls-6{fill:#ffd4a7;}.cls-7{fill:#fff;opacity:0.5;mix-blend-mode:soft-light;}.cls-8{fill:#fff4d3;}.cls-9{fill:#a58372;}.cls-10{fill:#ccedff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "img_chalice") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.42,39.94c-.09.77-1.51,1.44-3.94,1.89a49.31,49.31,0,0,1-8.73.65c-7.53,0-12.49-1.08-12.67-2.54s7.33-2.55,8.89-5.8a13,13,0,0,0,.72-1.87c0-.16.1-.31.14-.47a34.1,34.1,0,0,0,1-5.57c0-.28,0-.44,0-.44h3.73s0,.35.09.92a33.74,33.74,0,0,0,1,5.07l.21.68a13.35,13.35,0,0,0,.66,1.68C30.09,37.39,37.6,38.47,37.42,39.94Z",
    transform: "translate(-9.89 -7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.71,26.71a6.65,6.65,0,0,1-3.86-.48c0-.28,0-.44,0-.44h3.73S26.65,26.14,26.71,26.71Z",
    transform: "translate(-9.89 -7)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34.19,41.33a49.31,49.31,0,0,1-8.73.65C17.93,42,13,40.9,12.79,39.43A.56.56,0,0,1,13,39c-.59.32-1,.64-.91,1,.18,1.46,5.14,2.54,12.67,2.54a49.31,49.31,0,0,0,8.73-.65c1.89-.35,3.16-.83,3.68-1.39A11.41,11.41,0,0,1,34.19,41.33Z",
    transform: "translate(-9.89 -7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.88,32.46a9.72,9.72,0,0,1-6.19-.19c0-.16.1-.31.14-.47h5.84Z",
    transform: "translate(-9.89 -7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.42,39.94c-.09.77-1.51,1.44-3.94,1.89a2.39,2.39,0,0,0,.34-.21,1.57,1.57,0,0,0,.66-1.6A2,2,0,0,0,33.53,39c-1.44-.87-3.19-1.11-4.64-2a8.27,8.27,0,0,1-3.51-5,24.8,24.8,0,0,1-.65-6.2s0,0,0,0h1.87s.38,5.15,1.92,8.35S37.6,38.47,37.42,39.94Z",
    transform: "translate(-9.89 -7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M28.1,24.26a1.32,1.32,0,0,1-.31.83,4,4,0,0,1-3,1.13c-1.8,0-3.26-.83-3.34-1.87v-.09a1.31,1.31,0,0,1,.31-.82,4,4,0,0,1,3-1.13,5,5,0,0,1,2.12.44A1.83,1.83,0,0,1,28.1,24.26Z",
    transform: "translate(-9.89 -7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.1,24.26v.08a1.38,1.38,0,0,1-.31.75,18.24,18.24,0,0,1-4.43-.17,6.54,6.54,0,0,1-1.95-.57v-.09a1.79,1.79,0,0,1,0-.23,1.31,1.31,0,0,1,.29-.59,2.47,2.47,0,0,1,.36-.19,4.81,4.81,0,0,1,1.3-.35c.4-.06.81-.11,1.22-.14a14.9,14.9,0,0,1,1.64-.05,4.44,4.44,0,0,1,.63,0,3,3,0,0,1,.7.46A1.42,1.42,0,0,1,28.1,24.26Z",
    transform: "translate(-9.89 -7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.1,24.26v.08A14.61,14.61,0,0,1,21.43,24a1.31,1.31,0,0,1,.29-.59,2.47,2.47,0,0,1,.36-.19,4.81,4.81,0,0,1,1.3-.35c.4-.06.81-.11,1.22-.14a14.13,14.13,0,0,1,2.75.39l.22.06A1.42,1.42,0,0,1,28.1,24.26Z",
    transform: "translate(-9.89 -7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M24.75,10.23H9.89c.49,10.37,9.28,14,14.86,14s14.37-3.66,14.87-14Z",
    transform: "translate(-9.89 -7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.22,10.23A14,14,0,0,1,20.05,23.5a15.91,15.91,0,0,0,4.7.76c5.59,0,14.37-3.66,14.87-14Z",
    transform: "translate(-9.89 -7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M12.4,10.23H9.89c.49,10.37,9.28,14,14.86,14q.62,0,1.26-.06C20.46,23.7,12.87,19.85,12.4,10.23Z",
    transform: "translate(-9.89 -7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.33,10.23C33.91,19.07,27.46,23,22.11,24a14.77,14.77,0,0,0,2.64.25c5.59,0,14.37-3.66,14.87-14Z",
    transform: "translate(-9.89 -7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 14.87,
    cy: 3.23,
    rx: 14.87,
    ry: 3.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39,10.23c0,.34-.31.67-.87,1-2,1.1-7.23,1.88-13.37,1.88s-11.36-.78-13.36-1.88c-.57-.31-.87-.64-.87-1,0-1.58,6.37-2.86,14.23-2.86S39,8.65,39,10.23Z",
    transform: "translate(-9.89 -7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M38.12,11.21c-2,1.1-7.23,1.88-13.37,1.88s-11.36-.78-13.36-1.88c2-1.09,7.23-1.87,13.36-1.87S36.12,10.12,38.12,11.21Z",
    transform: "translate(-9.89 -7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M27.29,30.25c.06.29-.53.59-2.54.59s-2.59-.3-2.53-.59c-1.24.42-1.12,1.56-.49,1.89a8.16,8.16,0,0,0,3,.43,8.22,8.22,0,0,0,3-.43C28.41,31.81,28.53,30.67,27.29,30.25Z",
    transform: "translate(-9.89 -7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.78,31.67a8.14,8.14,0,0,1-3,.42,8.08,8.08,0,0,1-3-.42.89.89,0,0,1-.43-.57.91.91,0,0,0,.43,1,8.16,8.16,0,0,0,3,.43,8.22,8.22,0,0,0,3-.43.91.91,0,0,0,.43-1A.92.92,0,0,1,27.78,31.67Z",
    transform: "translate(-9.89 -7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgChalice);
export default __webpack_public_path__ + "static/media/img_chalice.5933d556dafe506d1598b72ba1a0db31.svg";
export { ForwardRef as ReactComponent };